'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * TableRow component.
 * Defines styling for a table row
 * Adds a <tr> element
 *
 * @extends {React.Component}
 * @property {Boolean} isHeader does not adds Table-row class to the element.
 * @property {Boolean} selected Shades the element as the selected row element.
 */
class TableRow extends React.Component {

  /**
   * Render the component
   *
   * @return {JSX} JSX component markup.
   **/
  render () {
    const { children, isHeader, selected, ...otherProps } = this.props;

    const classes = classNames({
      'Table-row': !isHeader,
      'Table-row--selected': selected,
      [`${this.props.className}`]: !!this.props.className
    });

    return (
      <tr {...otherProps} className={classes}>
        {children}
      </tr>
    );
  }
}

/**
 * @prop {propTypes} propTypes - required attributes for the TableRow component
 */
TableRow.propTypes = {
  isHeader: React.PropTypes.bool,
  selected: React.PropTypes.bool
};

TableRow.defaultProps = {
  isHeader: false,
  selected: false
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/table/tableRow.jsx